import { Wrapper, Content, Head } from './profile.styles';
import { ProfileEdit } from '@features/current-user/edit-profile/ui/profile-edit/profile-edit.tsx';
import { Button } from '@vtbhome/juicyfront';
import { ArrowsChevronLeft } from '@vtbhome/juicyfront/indexIcon';
import { useHistory } from 'react-router-dom';
import { Typography } from '@shared/ui/typography/typography';
import { CardAccountInfo } from '@entities/current-user/ui/card-account-info/card-account-info';
import { userName } from '@shared/lib/utils/user-name/user-name';
import { useCurrentUserSelector } from '@entities/current-user/model/selectors';
import { ProfilePhotoEdit } from '@features/current-user/edit-profile/ui/profile-photo-edit/profile-photo-edit';

export const ProfilePage = () => {
    const history = useHistory();
    const user = useCurrentUserSelector();

    return (
        <Wrapper>
            <Content>
                <Head>
                    {Boolean(history.length) && (
                        <Button
                            round
                            size='xl'
                            buttonType='secondary'
                            startAdornment={<ArrowsChevronLeft />}
                            onClick={() => history.goBack()}
                        />
                    )}
                    <Typography size='h6'>Редактирование профиля</Typography>
                </Head>

                <CardAccountInfo
                    avatarUrl={user?.photoUrl || ''}
                    name={userName({ ...user }).full}
                    role={user?.role.roleName || ''}
                    department={user?.department?.name || ''}>
                    <ProfilePhotoEdit isEditMode />
                </CardAccountInfo>
                <ProfileEdit />
            </Content>
        </Wrapper>
    );
};
